/**
 * weData.js — WE League (Japan Women's Empowerment Professional Football League)
 * 2025–26 season — 12 teams. INAC Kobe Leonessa leading.
 * Tokyo Verdy Beleza defending champions (2024–25).
 */

export const WE_SEASON     = '2025–26';
export const WE_WORKER_URL = 'https://we-proxy.footballgirl.workers.dev';

export const WE_STANDINGS_FALLBACK = [
  { pos:1,  name:'INAC Kobe Leonessa',      short:'KOB', color:'#E60026', zone:'champion', p:18, w:14, d:2, l:2,  gf:42, ga:10, gd:32,  pts:44, form:['D','L','W','W','W'] },
  { pos:2,  name:'Urawa Red Diamonds L.',   short:'URA', color:'#CC0000', zone:'top',      p:18, w:13, d:2, l:3,  gf:45, ga:11, gd:34,  pts:41, form:['W','L','W','W','W'] },
  { pos:3,  name:'NTV Tokyo Verdy Beleza',  short:'BEL', color:'#006633', zone:'top',      p:18, w:11, d:2, l:5,  gf:41, ga:19, gd:22,  pts:35, form:['W','W','W','L','L'] },
  { pos:4,  name:'Sanfrecce Hiroshima R.',  short:'HIR', color:'#6A0DAD', zone:'n',        p:18, w:7,  d:7, l:4,  gf:22, ga:19, gd:3,   pts:28, form:['L','W','W','W','D'] },
  { pos:5,  name:'Mynavi Sendai Ladies',    short:'SEN', color:'#FFD700', zone:'n',        p:18, w:7,  d:7, l:4,  gf:17, ga:14, gd:3,   pts:28, form:['D','L','W','D','L'] },
  { pos:6,  name:'Albirex Niigata Ladies',  short:'NIL', color:'#F36F21', zone:'n',        p:18, w:8,  d:3, l:7,  gf:20, ga:22, gd:-2,  pts:27, form:['L','W','W','D','D'] },
  { pos:7,  name:'RB Omiya Ardija Ventus',  short:'OMI', color:'#0066CC', zone:'n',        p:18, w:5,  d:7, l:6,  gf:21, ga:23, gd:-2,  pts:22, form:['D','W','L','W','L'] },
  { pos:8,  name:'JEF United Ichihara L.',  short:'JEF', color:'#FFCC00', zone:'n',        p:18, w:5,  d:5, l:8,  gf:14, ga:31, gd:-17, pts:20, form:['W','D','L','L','W'] },
  { pos:9,  name:'Nojima Stella Sagamihara',short:'NOJ', color:'#003087', zone:'n',        p:18, w:5,  d:3, l:10, gf:18, ga:32, gd:-14, pts:18, form:['W','D','L','L','W'] },
  { pos:10, name:'Cerezo Osaka Sakai',      short:'CER', color:'#FF69B4', zone:'n',        p:18, w:4,  d:4, l:10, gf:18, ga:30, gd:-12, pts:16, form:['D','L','L','D','L'] },
  { pos:11, name:'AS Elfen Saitama',        short:'ELF', color:'#008080', zone:'rel',      p:18, w:3,  d:3, l:12, gf:14, ga:31, gd:-17, pts:12, form:['L','W','L','L','W'] },
  { pos:12, name:'AC Parceiro Nagano L.',   short:'NAG', color:'#800000', zone:'rel',      p:18, w:1,  d:2, l:15, gf:9,  ga:42, gd:-33, pts:5,  form:['L','L','L','L','L'] },
];

export const WE_TOP_SCORERS_FALLBACK = [
  { initials:'MM', name:'Mana Mihashi',        club:'Urawa Red Diamonds', goals:12 },
  { initials:'HN', name:'Hinata Miyazawa',      club:'INAC Kobe Leonessa', goals:11 },
  { initials:'YU', name:'Yuka Momiki',          club:'NTV Tokyo Verdy B.', goals:9  },
  { initials:'MH', name:'Maika Hamano',         club:'INAC Kobe Leonessa', goals:8  },
  { initials:'RH', name:'Riko Ueki',            club:'Urawa Red Diamonds', goals:7  },
  { initials:'AF', name:'Aoba Fujino',          club:'NTV Tokyo Verdy B.', goals:6  },
];

export const WE_FIXTURES_FALLBACK = [
  { date:'2026-01-10', home:'INAC Kobe Leonessa', homeColor:'#E60026', homeGoals:5, awayGoals:1, away:'Elfen Saitama',     awayColor:'#008080', status:'FT' },
  { date:'2026-01-10', home:'Urawa Red Diamonds', homeColor:'#CC0000', homeGoals:4, awayGoals:0, away:'Parceiro Nagano',   awayColor:'#800000', status:'FT' },
  { date:'2026-01-11', home:'NTV Verdy Beleza',   homeColor:'#006633', homeGoals:3, awayGoals:1, away:'Cerezo Osaka',      awayColor:'#FF69B4', status:'FT' },
  { date:'2026-02-07', home:'INAC Kobe Leonessa', homeColor:'#E60026', homeGoals:null, awayGoals:null, away:'Urawa Red Diamonds', awayColor:'#CC0000', status:'NS' },
  { date:'2026-02-07', home:'NTV Verdy Beleza',   homeColor:'#006633', homeGoals:null, awayGoals:null, away:'Mynavi Sendai',      awayColor:'#FFD700', status:'NS' },
];

export async function fetchLiveWEData() {
  if (!WE_WORKER_URL || WE_WORKER_URL.includes('footballgirl')) {
    console.info('[WE] PROXY_URL not set — using fallback data.');
    return null;
  }
  try {
    const r = await fetch(WE_WORKER_URL, { signal: AbortSignal.timeout(6000) });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const d = await r.json();
    return {
      standings:  d.standings  ?? WE_STANDINGS_FALLBACK,
      topScorers: d.topScorers ?? WE_TOP_SCORERS_FALLBACK,
      fixtures:   d.fixtures   ?? WE_FIXTURES_FALLBACK,
    };
  } catch (e) {
    console.warn('[WE] Live fetch failed, using fallback:', e.message);
    return null;
  }
}
